module.exports = __webpack_public_path__ + "static/img/68f438cb-9b5a-4073-9405-ba3208136bc5.b389fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/68f438cb-9b5a-4073-9405-ba3208136bc5.png
// module id = YHjI
// module chunks = 1